import React from "react";

const TALLY_FORM_URL = "https://tally.so/r/wbA5y7";

const Form: React.FC = () => (
  <div className="w-screen h-screen">
    <iframe
      src={TALLY_FORM_URL}
      className="w-full h-full border-none"
      title="Startup Valuation Form"
    ></iframe>
  </div>
);

export default Form; 